<template>
  <div>
    <form-bread-crumb :title="'Role Details'" />

    <unprivilege-panel v-if="getterUnprivilegePage === 'RoleDetails'" :css="'details-panel'" />
    <div v-else>
      <role-form :roleFormOptions="roleFormOptions" :isCreateAction="isCreateAction" />

      <users-list v-if="userReadAccess && !isCreateAction" :users="usersList" :dataAdded="dataAdded" />
      <unprivilege-panel v-else-if="!isCreateAction" :title="'Users'" />
    </div>
  </div>
</template>

<script>
import UsersList from '@/components/Roles/UsersList'
import RoleForm from '@/components/Roles/RoleForm'
import FormBreadCrumb from '@/components/global/FormBreadCrumb'
import UnprivilegePanel from '@/components/global/UnprivilegePanel'

import ApiServices from '@/services/api/roles'
import { mapGetters } from 'vuex'

export default {
  name: 'RoleDetails',
  components: { UsersList, RoleForm, FormBreadCrumb, UnprivilegePanel },
  data () {
    return {
      usersList: [],
      roleFormOptions: {},
      isCreateAction: false,
      userReadAccess: true,
      dataAdded: false
    }
  },
  watch: {
    '$route': {
      handler: 'decideAction',
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['getterUnprivilegePage'])
  },
  methods: {
    decideAction () {
      if (this.$route.name === 'RoleDetails') {
        this.populateData()
        this.isCreateAction = false
      } else {
        this.checkCreateAccess()
        this.isCreateAction = true
      }
    },
    populateData () {
      ApiServices.roleDetails(this.$route.params.id).then(response => {
        let data = response.data
        if (data) {
          this.usersList = data.users || []
          this.roleFormOptions = {
            isCreateAction: false,
            data: data,
            totalUsers: this.usersList.length,
            manageAccess: response.privileges.manage_roles
          }
          this.userReadAccess = response.privileges.read_users
          this.dataAdded = true
        }
      }).catch((error) => {
        if (error.status === 404) {
          this.$router.push({name: 'RolesList'})
        }
      })
    },
    checkCreateAccess () {
      ApiServices.newRoleAccess().then(response => {
        this.roleFormOptions = {
          isCreateAction: true,
          data: response.data
        }
      })
    }
  }
}
</script>
